import apiClient from './client';
import { LotteryInfo, PaginationParams, PaginationData } from '../types';

/**
 * 获取最新开奖信息
 * FastAdmin 路由：使用 openlive/getlive
 */
export const getLatestLottery = (type: number) => {
  return apiClient.post<any>('openlive/getlive', { lotteryType: type });
};

/**
 * 获取开奖历史
 */
export const getLotteryHistory = (params: PaginationParams & { type: number }) => {
  return apiClient.get<PaginationData<LotteryInfo>>('lottery/history', { params });
};

/**
 * 获取开奖详情
 */
export const getLotteryDetail = (id: number) => {
  return apiClient.get<LotteryInfo>(`lottery/detail/${id}`);
};

/**
 * 获取开奖统计
 */
export const getLotteryStats = (type: number, params?: any) => {
  return apiClient.get('lottery/stats', { params: { type, ...params } });
};

/**
 * 获取3D开奖信息
 */
export const get3DLatest = () => {
  return apiClient.get<LotteryInfo>('lottery/3d/latest');
};

/**
 * 获取3D开奖历史
 */
export const get3DHistory = (params: PaginationParams & { year?: number }) => {
  return apiClient.get<PaginationData<LotteryInfo>>('lottery/3d/history', { params });
};

/**
 * 获取开奖直播地址
 */
export const getLiveUrl = (type: number) => {
  return apiClient.get<{ url: string }>('lottery/live', { params: { type } });
};
